





























import app from "@/app";
import { SXCompany, SXSector } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WCompaniesList extends BaseComponent {
	@Prop({ type: Array, required: true })
	companies!: SXCompany[];

	userCanEditCompany(company: SXCompany) {
		return app.services.users.isCompanyAdmin(company.id);
	}
}
